<template>
  <Benefit>
    {{ i18n(translations.title) }}
    <template #appendix>
      <div class="space-y-20">
        <div>{{ i18n(translations.body) }}</div>

        <div class="caption">{{ i18n(translations.note) }}</div>
      </div>
    </template>
  </Benefit>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import Benefit from '../Benefit/Benefit.vue'

import translations from './NetworkQuality.translations'

const i18n = useI18n()
</script>
